module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_14.303693c9.png";